import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowSpinLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.684 13.722a.6.6 0 0 1-1.2 0v-.412c-.49.467-1.112.835-1.735 1.1-1.168.496-2.554.73-3.629.542-1.945-.34-3.234-1.089-3.74-1.594a.6.6 0 0 1 .848-.85c.284.285 1.321.952 3.098 1.263.787.137 1.935-.032 2.954-.465.72-.306 1.275-.698 1.605-1.114l-.905.172a.6.6 0 0 1-.225-1.179l2.216-.422.713-.137zM8 5.222a2.79 2.79 0 0 1 2.792 2.793l-.014.285a2.792 2.792 0 0 1-5.555 0l-.015-.285A2.793 2.793 0 0 1 8 5.223m0 1.2a1.592 1.592 0 1 0 0 3.185 1.592 1.592 0 0 0 0-3.184M5.265 1.619c1.168-.496 2.554-.73 3.629-.542 1.945.34 3.234 1.089 3.74 1.594a.6.6 0 0 1-.848.85c-.285-.285-1.321-.952-3.098-1.262-.787-.137-1.935.032-2.955.465-.719.305-1.274.698-1.604 1.113l.904-.172a.6.6 0 0 1 .226 1.179l-2.216.423-.713.136V2.307a.6.6 0 0 1 1.2 0v.412c.489-.468 1.112-.836 1.735-1.1"
            />
        </svg>
    );
}
export default memo(IconArrowSpinLeft16);
